import makeStyles from '@material-ui/core/styles/makeStyles';
import createStyles from '@material-ui/core/styles/createStyles';

import { CalloutMessageProps } from './index';

const useStyles = makeStyles(
  createStyles({
    root: (props: CalloutMessageProps) => ({
      margin: props.margin ? '12px 0' : 0,
      width: '100%',
    }),
    icon: {},
    message: {},
    action: {},
  })
);

export default useStyles;
